import React, { useState, useEffect, useCallback, useMemo } from "react";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/vp_style.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/AdminMain.css";
import MyLoader from "../Spinner/MyLoader";
import Login from "../login";
import {
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import SessionManager from "../Utils/SessionManager";
import axios from "axios";
import myToast from "../Utils/MyToast";
import { FaBell, FaBirthdayCake, FaBolt, FaBookOpen, FaBullhorn, FaBus, FaCalendarAlt, FaChartBar, FaCheckCircle, FaChevronLeft, FaChevronRight, FaExclamationCircle, FaFileAlt, FaHistory, FaIdCard, FaLayerGroup, FaLightbulb, FaQuestionCircle, FaReceipt, FaRupeeSign, FaSearch, FaStar, FaSyncAlt, FaTasks, FaThLarge, FaTimesCircle, FaUserGraduate, FaUserTie, FaUsers, FaWhatsapp } from "react-icons/fa";
import AttendancePieChart from "../ChildComponent/AttendancePieChart ";
import ModuleList from "./ModuleList";
import MdlSearchStudent from "../dialog/MdlSearchStudent";
import StaffPrivilege from "./StaffPrivilege";
import Security from "./Security";
import Settlement from "./Settlement";
import SettlementFeeAdvance from "./SettlementFeeAdvance";
import ViewSettlement from "./ViewSettlement";
import ClassList from "../cms/ClassList";
import NoticeBoard from "../cms/NoticeBoard";
import FeeDashBoard from "../cms/FeeDashBoard";
import AttendanceDashboard from "../cms/AttendanceDashboard";
import HelpDesk from "../cms/HelpDesk";
import AiAssistant from "../cms/AiAssistant";
import SupportChat from "../cms/SupportChat";
import Holiday from "../cms/Holiday";
import LeaveManagement from "../cms/LeaveManagement";
import Comment from "../cms/Comment";
import SchoolProfile from "../cms/SchoolProfile";
import SchoolAffiliations from "../cms/SchoolAffiliations";
import AdminNotification from "./AdminNotification";
import LeaveManagementAdmin from "./LeaveManagementAdmin";
import ManageRecords from "./ManageRecords";
import RevenueManagement from "./RevenueManagement";
import Transport from "../cms/Transport";
import Academic from "../cms/Academic";
import HostelManagement from "../cms/HostelManagement";
import HostelStudent from "../cms/HostelStudent";
import HostelStudentDetails from "../cms/HostelStudentDetails";
import AddHostelStudent from "../cms/AddHostelStudent";
import Notification from "../cms/Notification";
import LearningManagement from "../cms/LearningManagement";
import HomeWork from "../cms/HomeWork";
import HomeworkAssign from "../cms/HomeworkAssign";
import StaffList from "../cms/StaffList";
import Settings from "../cms/Settings";
import FineSettings from "../cms/FineSettings";
import MyProfile from "../cms/MyProfile";
import NavMenuAdmin from "./NavMenuAdmin";
import Error from "./Error";
import StudentList from "../cms/StudentList";

import PaymentHistory from "../cms/PaymentHistory";
import PaymentDetails from "../cms/PaymentDetails";

import StudentDetails from "../cms/StudentDetails";
import FeeCard from "../cms/FeeCard";
import AdvancedPayment from "../cms/AdvancedPayment";
import PaymentStatus from "../cms/PaymentStatus";
import FeeReceipt from "../cms/FeeReceipt";
import FeeCollection from "../cms/FeeCollection";
import CurrentDue from "../cms/CurrentDue";
import StudentRegistration from "../cms/StudentRegistration";
import UpdateSchoolDetails from "../cms/UpdateSchoolDetails";
import AddHoliday from "../cms/AddHoliday";
import EditStaff from "../cms/EditStaff";
import StaffRegistration from "../cms/StaffRegistration";
import TotalRecieved from "../cms/TotalRecieved";
import UpdateStudentDetails from "../cms/UpdateStudentDetails";
import ManageNotice from "../cms/ManageNotice";
import SendNotification from "../cms/SendNotification";
import AddNotice from "../cms/AddNotice";
import Accessories from "../cms/Accessories";
import TotalDue from "../cms/TotalDue";
import TotalFee from "../cms/TotalFee";
import TotalSettled from "../cms/TotalSettled";
import FeeStructureManager from "../cms/FeeStructureManager";
import Acknowledgement from "../cms/Acknowledgement";
import AdmissionForm from "../cms/AdmissionForm";
import StRegSuccessfull from "../cms/StRegSuccessfull";
import OldDueList from "./OldDueList";
import OldDueCollection from "./OldDueCollection";
import ExamList from "../cms/ExamList";
import ClassTestList from "../cms/ClassTestList";
import TestScore from "../cms/TestScore";
import FeeOtherAmount from "../cms/FeeOtherAmount";
import ClassSettings from "../cms/ClassSettings";
import ClassFee from "../cms/ClassFee";
import AddClassFee from "../cms/AddClassFee";
import FeeNameList from "../cms/FeeNameList";
import SpecialCaseStudent from "../cms/SpecialCaseStudent";
import SpecialCaseCreation from "../cms/SpecialCaseCreation";
import RteStudent from "../cms/RteStudent";
import RteCreation from "../cms/RteCreation";
import AdmissionQuery from "../cms/AdmissionQuery";
import AdmissionQueryDetails from "../cms/AdmissionQueryDetails";
import AdmissionLink from "../cms/AdmissionLink";
import RegistrationFee from "../cms/RegistrationFee";
import VendorRegistration from "../cms/VendorRegistration";
import MyVendor from "../cms/MyVendor";
import ExamTopperList from "../cms/ExamTopperList";
import ExamPaperSettings from "../cms/ExamPaperSettings";
import ExamClassResultStatus from "../cms/ExamClassResultStatus";
import ExamDetails from "../cms/ExamDetails";
import ExamClassResult from "../cms/ExamClassResult";
import ExamStudentResult from "../cms/ExamStudentResult";
import ExamReportCardList from "../cms/ExamReportCardList";
import ExamStudentReportCard from "../cms/ExamStudentReportCard";
import ManageManualAttendance from "../cms/ManageManualAttendance";
import Attendance from "../cms/Attendance";
import PrintMaster from "../cms/PrintMaster";
import StudentIdCard from "../cms/StudentIdCard";
import ExamAdmitCard from "../cms/ExamAdmitCard";
import ExamDateSheet from "../cms/ExamDateSheet";
import ExamGuideline from "../cms/ExamGuideline";
import ExamHallTicket from "../cms/ExamHallTicket";
import ReportManagement from "./ReportManagement";
import ReportViewClass from "./ReportViewClass";
import DataCenter from "./DataCenter";
import StudentData from "./StudentData";
import ExamMarkingSystem from "../cms/ExamMarkingSystem";
import ExamMarkingSystemAnnual from "../cms/ExamMarkingSystemAnnual";
import TransactionPanel from "../cms/TransactionPanel";
import PrintableDocs from "../cms/PrintableDocs";
import PdAdmissionForm from "../cms/PdAdmissionForm";
import COLORS from "../resources/colors/COLORS";
import AccountAccessBlock, {
  resolveProductAccess,
} from "./AccountAccessBlock";
import Siblings from "../cms/Siblings";
import PrintableDocsAdmitCard from "../cms/PrintableDocsAdmitCard";
import PrintableDocsResult from "../cms/PrintableDocsResult";
import PrintableDocsBlank from "../cms/PrintableDocsBlank";
import TransportRoutes from "../cms/TransportRoutes";
import TransportVehicles from "../cms/TransportVehicles";
import TransportStudent from "../cms/TransportStudent";
import TransportAddNewRoute from "../cms/TransportAddNewRoute";
import ExamCreation from "../cms/ExamCreation";
import ClassChange from "../cms/ClassChange";
import SessionJump from "../cms/SessionJump";
import SectionShift from "../cms/SectionShift";
import TransferCertificate from "../cms/TransferCertificate";
import TransferCertificateForm from "../cms/TransferCertificateForm";
import TransferCertificatePreview from "../cms/TransferCertificatePreview";
import SrNumber from "../cms/SrNumber";
import EditStudentDetails from "../cms/EditStudentDetails";
import SubjectList from "../cms/SubjectList";
import ClassSubject from "../cms/ClassSubject";
import QuestionBank from "../cms/QuestionBank.js";
import AddQuestionBank from "../cms/AddQuestionBank.js";
import PaperBuilder from "../cms/PaperBuilder.js";
import PrintQuestionPaper from "../cms/PrintQuestionPaper.js";
import TimetableBuilder from "../cms/TimetableBuilder.js";
import QuestionPapers from "../cms/QuestionPapers.js";
import ClassMarkStatus from "../cms/ClassMarkStatus";
import StudentMarkDetails from "../cms/StudentMarkDetails";
import ExamAddSingleStudentMark from "../cms/ExamAddSingleStudentMark";
import StaffProfile from "../cms/StaffProfile";
import SignSettings from "../cms/SignSettings";
import FontSettings from "../cms/FontSettings";
import CertificateSettings from "../cms/CertificateSettings";
import BoardMediumSettings from "../cms/BoardMediumSettings";

import SessionSettings from "../cms/SessionSettings";
import RollNumberManagement from "../cms/RollNumberManagement";
import ManageAdmissionDate from "../cms/ManageAdmissionDate";
import ManageAdmissionType from "../cms/ManageAdmissionType";
import StateSpecificId from "../cms/StateSpecificId";
import Dob from "../cms/Dob";
import DepartmentSettings from "../cms/DepartmentSettings";
import FeeReceiptSettings from "../cms/FeeReceiptSettings";
import StudentManagement from "./StudentManagement";
import StaffManagement from "../cms/StaffManagement";
import StaffSubject from "../cms/StaffSubject.js";
import ActivityManagement from "../cms/ActivityManagement.js";
import LessonPlan from "../cms/LessonPlan.js";
import LessonPlanEditor from "../cms/LessonPlanEditor.js";
import StaffAttendanceDash from "../cms/StaffAttendanceDash";
import StaffAttendance from "../cms/StaffAttendance";
import StaffMonthAttendance from "../cms/StaffMonthAttendance";
import StaffAttendanceDetail from "../cms/StaffAttendanceDetail";
import StaffBiometricId from "../cms/StaffBiometricId";
import AddNewSibling from "../cms/AddNewSibling";
import DeleteStudent from "./DeleteStudent";
import DeleteStaff from "./DeleteStaff";
import DeleteExam from "./DeleteExam";
import ExamAddMarkStudentWise from "../cms/ExamAddMarkStudentWise";
import ExamAddMarkSubjectWise from "../cms/ExamAddMarkSubjectWise";
import PrintableDocsTopper from "../cms/PrintableDocsTopper";
import CompetitionAward from "../cms/CompetitionAward";
import ExamReportCardRankList from "../cms/ExamReportCardRankList";
import ExamReportCardResultSheet from "../cms/ExamReportCardResultSheet";
import ExamReportCardAttendanceReport from "../cms/ExamReportCardAttendanceReport";
import SchoolWorkingDays from "../cms/SchoolWorkingDays";
import ExamReportCardCrossList from "../cms/ExamReportCardCrossList";
import PrintableDocsIdCard from "../cms/PrintableDocsIdCard";
import BloodGroup from "../cms/BloodGroup";
import Aadhaar from "../cms/Aadhaar";
import ParentsAadhar from "../cms/ParentsAadhar";
import ManageStudentApaar from "../cms/ManageStudentApaar";
import ManageStudentImage from "../cms/ManageStudentImage";
import Gender from "../cms/Gender";
import MotherTongue from "../cms/MotherTongue";
import HeightAndWeight from "../cms/HeightAndWeight";
import BplBeneficiary from "../cms/BplBeneficiary";
import PhysicalDisability from "../cms/PhysicalDisability";
import StudentPen from "../cms/StudentPen";
import ExamSignSheet from "../cms/ExamSignSheet";
import TodayAttendance from "../cms/TodayAttendance";
import DemandSlip from "../cms/DemandSlip";
import UdiseForm from "../cms/UdiseForm.js";
import StudentAttendanceReport from "../cms/StudentAttendanceReport.js";
import AlternateSubject from "../cms/AlternateSubject.js";
import StudentSubject from "../cms/StudentSubject.js";
import MarkEntryForm from "../cms/MarkEntryForm.js";
import MarkEntryCheckList from "../cms/MarkEntryCheckList.js";
import ExamSchedule from "../cms/ExamSchedule.js";
import StudentDueList from "../cms/StudentDueList.js";
import PrintableDocsEvent from "../cms/PrintableDocsEvent.js";
import EventInvitation from "../cms/EventInvitation.js";
import EventCertificate from "../cms/EventCertificate.js";
import StaffOfferLetter from "../cms/StaffOfferLetter.js";
import LetterHead from "../cms/LetterHead.js";
import TransportRoutesDetails from "../cms/TransportRoutesDetails.js";
import AccessoriesAddCategory from "../cms/AccessoriesAddCategory.js";
import IssueAccessories from "../cms/IssueAccessories.js";
import AccessoriesList from "../cms/AccessoriesList.js";
import AccessoriesCollection from "../cms/AccessoriesCollection.js";
import AccessoriesDetails from "../cms/AccessoriesDetails.js";
import AppUser from "./AppUser.js";
import AddOldDue from "./AddOldDue.js";
import DemandNotice from "../cms/DemandNotice.js";
import StaffLeaveDetails from "./StaffLeaveDetails.js";
import StudentPassword from "./StudentPassword.js";
import StaffLeave from "../cms/StaffLeave.js";
import StudentLeave from "../cms/StudentLeave.js";
import PromoteStudent from "../cms/PromoteStudent.js";
import PromoteTransportStudent from "../cms/PromoteTransportStudent.js";
import ManageTransportFee from "../cms/ManageTransportFee.js";
import TransportAttendance from "../cms/TransportAttendance.js";
import TransportPermission from "../cms/TransportPermission.js";
import DriverDetails from "../cms/DriverDetails.js";
import OldDueOtherAmount from "./OldDueOtherAmount.js";
import MonthAttendance from "../cms/MonthAttendance.js";
import StudentAttendanceList from "../cms/StudentAttendanceList.js";
import StudentAttendanceDetail from "../cms/StudentAttendanceDetail.js";
import TransportStudentDetails from "../cms/TransportStudentDetails.js";
import AddTransportStudent from "../cms/AddTransportStudent.js";
import AddTransportStudentMultiple from "../cms/AddTransportStudentMultiple.js";
import ExamReportCardGauzzat from "../cms/ExamReportCardGauzzat.js";
import UdiseReport from "../cms/UdiseReport.js";
import ManageCategory from "../cms/ManageCategory.js";
import ManageCaste from "../cms/ManageCaste.js";
import ManageStudentContacts from "../cms/ManageStudentContacts.js";
import { jwtDecode } from "jwt-decode";
import PrintableDocsStaffId from "../cms/PrintableDocsStaffId.js";
import TransportReport from "../cms/TransportReport.js";
import PayRoll from "../cms/PayRoll.js";
import PayRollAddStaff from "../cms/PayRollAddStaff.js";
import PayRollSettings from "../cms/PayRollSettings.js";
import PayRollAddSalary from "../cms/PayRollAddSalary.js";
import PayRollSalaryDetails from "../cms/PayRollSalaryDetails.js";
import PayRollPayslip from "../cms/PayRollPayslip.js";
import PayRollStaffList from "../cms/PayRollStaffList.js";
import PayRollStaffDetail from "../cms/PayRollStaffDetail.js";
import PrintableDocsDeskSlip from "../cms/PrintableDocsDeskSlip.js";
import WhatsAccountSettings from "../cms/WhatsAccountSettings";
import CommunicationPanel from "../cms/CommunicationPanel";
import CommWhatsAppQueue from "../cms/communication/CommWhatsAppQueue";
import CommWhatsAppInbox from "../cms/communication/CommWhatsAppInbox";
import FineRuleSettings from "../cms/FineRuleSettings";
import ExpenseManager from "../cms/ExpenseManager.js";
import ExpenseReport from "../cms/ExpenseReport.js";
import StatementManager from "../cms/StatementManager.js";
import ExpenseList from "../cms/ExpenseList.js";
import ManageSocialValueField from "../cms/ManageSocialValueField.js";
import ManageCoEducationField from "../cms/ManageCoEducationField.js";
import AddMarkCoEducationField from "../cms/AddMarkCoEducationField.js";
import AddExamSocialValueField from "../cms/AddExamSocialValueField.js";
import CollectionReport from "../cms/CollectionReport.js";
import EventList from "../cms/EventList.js";
import ManageEventParticipant from "../cms/ManageEventParticipant.js";
import AdmissionDashboard from "../cms/AdmissionDashboard";
import AppreciationCertificate from "../cms/AppreciationCertificate.js";
import StudentCertificate from "../cms/StudentCertificate.js";

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor
function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString("en-IN", {
    maximumFractionDigits: 0,
  });
}

//Created By Cursor
function findModulePath(modules, componentName, fallback) {
  const hit = (modules || []).find(
    (m) => String(m?.component_name || "") === componentName
  );
  if (hit?.module_id != null && hit.module_id !== "") {
    return `/AdminMain/${componentName}/${hit.module_id}`;
  }
  return fallback;
}

//Created By Cursor
function attendancePct(part, total) {
  const t = Number(total) || 0;
  const p = Number(part) || 0;
  if (t <= 0) return 0;
  return Math.floor((p * 100) / t);
}

//Created By Cursor
function ClassAttendanceByDate({ initial, loadingDate = false, onDateChange }) {
  const todayStr = useMemo(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }, []);

  const [selectedDate, setSelectedDate] = useState(
    () => String(initial?.date || todayStr)
  );

  useEffect(() => {
    const nextDate = String(initial?.date || todayStr);
    setSelectedDate(nextDate);
  }, [initial?.date, todayStr]);

  const classes = Array.isArray(initial?.classes) ? initial.classes : [];

  //Created By Cursor
  const handleDateChange = useCallback(
    (e) => {
      const next = e.target.value || todayStr;
      setSelectedDate(next);
      if (typeof onDateChange === "function") {
        onDateChange(next);
      }
    },
    [onDateChange, todayStr]
  );

  const maxCount = useMemo(() => {
    let max = 1;
    classes.forEach((row) => {
      const p = Number(row.P || 0);
      const a = Number(row.A || 0);
      if (p > max) max = p;
      if (a > max) max = a;
    });
    return max;
  }, [classes]);

  const totals = useMemo(() => {
    let p = 0;
    let a = 0;
    let marked = 0;
    classes.forEach((row) => {
      p += Number(row.P || 0);
      a += Number(row.A || 0);
      marked += Number(row.marked || 0);
    });
    return { p, a, marked };
  }, [classes]);

  return (
    <section className="adm-class-att" aria-label="Class attendance">
      <div className="adm-class-att__head">
        <div className="adm-class-att__title">
          <span className="adm-class-att__icon" aria-hidden>
            <FaChartBar />
          </span>
          <h2>Class attendance</h2>
          <span className="adm-class-att__totals" aria-label="Day totals">
            <em className="is-p">
              Present <strong>{loadingDate ? "…" : totals.p}</strong>
            </em>
            <em className="is-a">
              Absent <strong>{loadingDate ? "…" : totals.a}</strong>
            </em>
          </span>
        </div>
        <div className="adm-class-att__tools">
          <div className="adm-class-att__legend" aria-hidden>
            <span className="adm-class-att__legend-item is-p">P</span>
            <span className="adm-class-att__legend-item is-a">A</span>
          </div>
          <label className="adm-class-att__date-field">
            <input
              type="date"
              value={selectedDate}
              max={todayStr}
              onChange={handleDateChange}
              disabled={loadingDate}
              aria-label="Select attendance date"
            />
          </label>
        </div>
      </div>

      {loadingDate ? (
        <p className="adm-kpi__empty-note">Loading…</p>
      ) : classes.length === 0 ? (
        <p className="adm-kpi__empty-note">No classes found</p>
      ) : (
        <div className="adm-class-att__chart-wrap">
          <div className="adm-class-att__chart">
            {classes.map((row) => {
              const p = Number(row.P || 0);
              const a = Number(row.A || 0);
              const marked = Number(row.marked || 0);
              const taken = row.status === "Taken" || marked > 0;
              const pH = taken ? Math.max(p > 0 ? 8 : 0, (p / maxCount) * 100) : 0;
              const aH = taken ? Math.max(a > 0 ? 8 : 0, (a / maxCount) * 100) : 0;

              return (
                <div key={row.class_id} className="adm-class-att__col">
                  <div
                    className="adm-class-att__bars"
                    title={
                      taken
                        ? `P ${p} · A ${a}`
                        : `${row.class_name || row.class_id}: not taken`
                    }
                  >
                    <div className="adm-class-att__vbar">
                      <i className="is-p" style={{ height: `${pH}%` }} />
                      <span className="is-p">{taken ? p : "—"}</span>
                    </div>
                    <div className="adm-class-att__vbar">
                      <i className="is-a" style={{ height: `${aH}%` }} />
                      <span className="is-a">{taken ? a : "—"}</span>
                    </div>
                  </div>
                  <div className="adm-class-att__xlabel">
                    {row.class_name || row.class_id}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}

//Created By Cursor
function AttendanceBreakdown({ rows, ready }) {
  if (!ready) {
    return (
      <div className="mat-report-breakdown">
        <p className="adm-kpi__empty-note">No attendance taken yet</p>
      </div>
    );
  }

  return (
    <div className="mat-report-breakdown">
      {rows.map((row) => (
        <div key={row.key} className={`mat-report-bar ${row.tone}`}>
          <div className="mat-report-bar__meta">
            <span>
              {row.icon}
              {row.label}
            </span>
            <strong>
              {row.value}
              <small>{row.pct}%</small>
            </strong>
          </div>
          <div className="mat-report-bar__track" aria-hidden>
            <i style={{ width: `${Math.min(100, row.pct)}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}

//Created By Cursor — last 3 days vertical P/A bars (staff / student attendance cards)
function Attendance3dBars({ days, label = "Last 3 days" }) {
  const list = Array.isArray(days) ? days : [];
  const maxCount = useMemo(() => {
    let max = 1;
    list.forEach((d) => {
      const p = Number(d.P || 0);
      const a = Number(d.A || 0);
      if (p > max) max = p;
      if (a > max) max = a;
    });
    return max;
  }, [list]);

  if (list.length === 0) {
    return (
      <div className="adm-stu-3d">
        <p className="adm-kpi__empty-note">No 3-day data</p>
      </div>
    );
  }

  return (
    <div className="adm-stu-3d" aria-label={label}>
      <div className="adm-stu-3d__chart">
        {list.map((d) => {
          const p = Number(d.P || 0);
          const a = Number(d.A || 0);
          const taken = d.status === "Taken" || Number(d.marked || 0) > 0;
          const pH = taken ? Math.max(p > 0 ? 8 : 0, (p / maxCount) * 100) : 0;
          const aH = taken ? Math.max(a > 0 ? 8 : 0, (a / maxCount) * 100) : 0;
          return (
            <div key={d.date} className="adm-stu-3d__col">
              <div
                className="adm-stu-3d__bars"
                title={taken ? `P ${p} · A ${a}` : "Not taken"}
              >
                <div className="adm-stu-3d__vbar">
                  <i className="is-p" style={{ height: `${pH}%` }} />
                  <span className="is-p">{taken ? p : "—"}</span>
                </div>
                <div className="adm-stu-3d__vbar">
                  <i className="is-a" style={{ height: `${aH}%` }} />
                  <span className="is-a">{taken ? a : "—"}</span>
                </div>
              </div>
              <div className="adm-stu-3d__xlabel">{d.label || d.date}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

//Created By Cursor
function DashboardKpiPanel({
  kpi,
  modules,
  announcements,
  classAttLoading = false,
  onClassAttDateChange,
}) {
  if (!kpi) {
    return <AnnouncementPanel items={announcements} />;
  }

  const staff = kpi.staff_attendance || {};
  const student = kpi.student_attendance || {};
  const staffMarked = Number(staff.marked || 0);
  const studentMarked = Number(student.marked || 0);
  //Created By Cursor — treat marked > 0 as taken even if status string mismatches
  const staffTaken = staff.status === "Taken" || staffMarked > 0;
  const studentTaken = student.status === "Taken" || studentMarked > 0;

  const staffBars = [
    {
      key: "p",
      label: "Present",
      value: Number(staff.P || 0),
      pct: attendancePct(staff.P, staffMarked),
      tone: "is-p",
      icon: <FaCheckCircle aria-hidden />,
    },
    {
      key: "a",
      label: "Absent",
      value: Number(staff.A || 0),
      pct: attendancePct(staff.A, staffMarked),
      tone: "is-a",
      icon: <FaTimesCircle aria-hidden />,
    },
    {
      key: "l",
      label: "Leave",
      value: Number(staff.L || 0),
      pct: attendancePct(staff.L, staffMarked),
      tone: "is-l",
      icon: <FaCalendarAlt aria-hidden />,
    },
  ];

  const studentBars = [
    {
      key: "p",
      label: "Present",
      value: Number(student.P || 0),
      pct: attendancePct(student.P, studentMarked),
      tone: "is-p",
      icon: <FaCheckCircle aria-hidden />,
    },
    {
      key: "a",
      label: "Absent",
      value: Number(student.A || 0),
      pct: attendancePct(student.A, studentMarked),
      tone: "is-a",
      icon: <FaTimesCircle aria-hidden />,
    },
    {
      key: "l",
      label: "Leave",
      value: Number(student.L || 0),
      pct: attendancePct(student.L, studentMarked),
      tone: "is-l",
      icon: <FaCalendarAlt aria-hidden />,
    },
  ];

  const staffPath = "/AdminMain/StaffAttendanceDash";
  const studentPath = findModulePath(
    modules,
    "AttendanceDashboard",
    "/AdminMain/AttendanceDashboard/0"
  );
  const feePath = findModulePath(modules, "FeeDashBoard", "/AdminMain/FeeCollection");
  const expensePath = findModulePath(
    modules,
    "ExpenseManager",
    "/AdminMain/ExpenseManager/0"
  );
  const admissionPath = findModulePath(
    modules,
    "AdmissionDashboard",
    "/AdminMain/AdmissionDashboard/0"
  );
  const transportPath = findModulePath(modules, "Transport", "/AdminMain/TransportStudent");
  const staffHubPath = "/AdminMain/StaffManagement";
  const tcPath = "/AdminMain/TransferCertificate";
  const studentHubPath = findModulePath(
    modules,
    "AttendanceDashboard",
    "/AdminMain/ManageRecords"
  );

  return (
    <section className="adm-kpi" aria-label="Dashboard insights">
      <div className="adm-kpi__metrics adm-kpi__metrics--top">
        <Link to={studentHubPath} className="adm-kpi__metric">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaUsers />
          </span>
          <span className="adm-kpi__metric-copy">
            <small>Total student</small>
            <strong>{Number(kpi.total_student || 0)}</strong>
            <em>Active this session</em>
          </span>
        </Link>
        <Link to={staffHubPath} className="adm-kpi__metric">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaUserTie />
          </span>
          <span className="adm-kpi__metric-copy">
            <small>Staff</small>
            <strong>{Number(kpi.total_staff || 0)}</strong>
            <em>Active staff</em>
          </span>
        </Link>
        <Link to={transportPath} className="adm-kpi__metric">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaBus />
          </span>
          <span className="adm-kpi__metric-copy">
            <small>Transport student</small>
            <strong>{Number(kpi.transport_student || 0)}</strong>
            <em>On transport</em>
          </span>
        </Link>
        <Link to={admissionPath} className="adm-kpi__metric">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaUserGraduate />
          </span>
          <span className="adm-kpi__metric-copy">
            <small>New admission</small>
            <strong>{Number(kpi.admission_today || 0)}</strong>
            <em>
              Today {Number(kpi.admission_today || 0)} · Month{" "}
              {Number(kpi.admission_month || 0)}
            </em>
          </span>
        </Link>
        <Link to={tcPath} className="adm-kpi__metric">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaFileAlt />
          </span>
          <span className="adm-kpi__metric-copy">
            <small>TC</small>
            <strong>{Number(kpi.tc_today || 0)}</strong>
            <em>
              Today {Number(kpi.tc_today || 0)} · Month{" "}
              {Number(kpi.tc_month || 0)}
            </em>
          </span>
        </Link>
      </div>

      <AnnouncementPanel items={announcements} />

      <div className="adm-kpi__graphs">
        <div className="mat-report-card adm-kpi__report adm-kpi__report--att3d">
          <div className="mat-report-card__head">
            <div className="mat-report-card__title">
              <span className="mat-report-card__icon" aria-hidden>
                <FaUserTie />
              </span>
              <div className="min-w-0">
                <h2>Staff attendance</h2>
                <p>
                  Today ·{" "}
                  {staffTaken
                    ? `${staffMarked} marked`
                    : "Not taken yet"}
                </p>
              </div>
            </div>
            <div className="adm-kpi__head-stats">
              <span className="adm-kpi__stat adm-kpi__stat--hd">
                Half day <strong>{staffTaken ? Number(staff.HD || 0) : "—"}</strong>
              </span>
              <span className="adm-kpi__stat adm-kpi__stat--la">
                Late <strong>{staffTaken ? Number(staff.LA || 0) : "—"}</strong>
              </span>
              <div className="adm-stu-3d__legend" aria-hidden>
                <span className="is-p">P</span>
                <span className="is-a">A</span>
              </div>
              <Link to={staffPath} className="adm-kpi__link">
                Open
              </Link>
            </div>
          </div>
          <div className="mat-report-body">
            <div className="mat-report-chart">
              <AttendancePieChart
                Present={staffTaken ? staff.P : "N/A"}
                Absent={staffTaken ? staff.A : "N/A"}
                Leave={staffTaken ? staff.L : "N/A"}
                size={96}
                showLegend={false}
                compact
              />
            </div>
            <AttendanceBreakdown rows={staffBars} ready={staffTaken} />
            <Attendance3dBars
              days={kpi.staff_attendance_3d}
              label="Staff attendance last 3 days"
            />
          </div>
        </div>

        <div className="mat-report-card adm-kpi__report adm-kpi__report--att3d">
          <div className="mat-report-card__head">
            <div className="mat-report-card__title">
              <span className="mat-report-card__icon" aria-hidden>
                <FaUserGraduate />
              </span>
              <div className="min-w-0">
                <h2>Student attendance</h2>
                <p>
                  Today ·{" "}
                  {studentTaken
                    ? `${studentMarked} marked`
                    : "Not taken yet"}
                </p>
              </div>
            </div>
            <div className="adm-kpi__head-stats">
              <div className="adm-stu-3d__legend" aria-hidden>
                <span className="is-p">P</span>
                <span className="is-a">A</span>
              </div>
              <Link to={studentPath} className="adm-kpi__link">
                Open
              </Link>
            </div>
          </div>
          <div className="mat-report-body">
            <div className="mat-report-chart">
              <AttendancePieChart
                Present={studentTaken ? student.P : "N/A"}
                Absent={studentTaken ? student.A : "N/A"}
                Leave={studentTaken ? student.L : "N/A"}
                size={96}
                showLegend={false}
                compact
              />
            </div>
            <AttendanceBreakdown rows={studentBars} ready={studentTaken} />
            <Attendance3dBars
              days={kpi.student_attendance_3d}
              label="Student attendance last 3 days"
            />
          </div>
        </div>
      </div>

      <ClassAttendanceByDate
        initial={kpi.class_attendance || { date: "", classes: [] }}
        loadingDate={classAttLoading}
        onDateChange={onClassAttDateChange}
      />

      <FinanceOpsPanel
        kpi={kpi}
        feePath={feePath}
        expensePath={expensePath}
        admissionPath={admissionPath}
      />

      <DashInsightQuad kpi={kpi} />

      <AdminQuickActions
        feePath={feePath}
        expensePath={expensePath}
        admissionPath={admissionPath}
        studentPath={studentPath}
        staffPath={staffPath}
        transportPath={transportPath}
      />
    </section>
  );
}

//Created By Cursor — quick actions strip (RevenueManagement-style)
function AdminQuickActions({
  feePath,
  expensePath,
  admissionPath,
  studentPath,
  staffPath,
  transportPath,
}) {
  const actions = [
    {
      id: "collect",
      label: "Collect Now",
      to: feePath || "/AdminMain/FeeCollection",
      tone: "green",
      icon: <FaRupeeSign aria-hidden />,
    },
    {
      id: "fee-card",
      label: "Fee Card",
      to: "/AdminMain/FeeCard",
      tone: "blue",
      icon: <FaIdCard aria-hidden />,
    },
    {
      id: "attendance",
      label: "Attendance",
      to: studentPath || "/AdminMain/AttendanceDashboard/0",
      tone: "indigo",
      icon: <FaUserGraduate aria-hidden />,
    },
    {
      id: "staff-att",
      label: "Staff Attendance",
      to: staffPath || "/AdminMain/StaffAttendanceDash",
      tone: "orange",
      icon: <FaUserTie aria-hidden />,
    },
    {
      id: "enquiry",
      label: "Admission Enquiry",
      to: "/AdminMain/AdmissionQuery",
      tone: "violet",
      icon: <FaQuestionCircle aria-hidden />,
    },
    {
      id: "admission",
      label: "New Admission",
      to: admissionPath || "/AdminMain/AdmissionDashboard/0",
      tone: "pink",
      icon: <FaUsers aria-hidden />,
    },
    {
      id: "homework",
      label: "Homework",
      to: "/AdminMain/HomeworkAssign",
      tone: "teal",
      icon: <FaBookOpen aria-hidden />,
    },
    {
      id: "notify",
      label: "Notification",
      to: "/AdminMain/AdminNotification",
      tone: "sky",
      icon: <FaBell aria-hidden />,
    },
    {
      id: "whatsapp",
      label: "WhatsApp",
      to: "/AdminMain/WhatsAppQueue",
      tone: "wa",
      icon: <FaWhatsapp aria-hidden />,
    },
    {
      id: "expense",
      label: "Expense",
      to: expensePath || "/AdminMain/ExpenseManager/0",
      tone: "red",
      icon: <FaReceipt aria-hidden />,
    },
    {
      id: "fee-structure",
      label: "Fee Structure",
      to: "/AdminMain/FeeStructureManager",
      tone: "cyan",
      icon: <FaLayerGroup aria-hidden />,
    },
    {
      id: "transport",
      label: "Transport",
      to: transportPath || "/AdminMain/TransportStudent",
      tone: "amber",
      icon: <FaBus aria-hidden />,
    },
    {
      id: "holiday",
      label: "Holiday",
      to: "/AdminMain/Holiday/0",
      tone: "star",
      icon: <FaStar aria-hidden />,
    },
    {
      id: "report",
      label: "Reports",
      to: "/AdminMain/AttendanceDashboard/0",
      tone: "slate",
      icon: <FaChartBar aria-hidden />,
    },
  ];

  return (
    <section className="adm-kpi__quick" aria-label="Quick actions">
      <div className="adm-kpi__quick-head">
        <FaBolt aria-hidden />
        <h2>Quick actions</h2>
      </div>
      <div className="adm-kpi__quick-grid">
        {actions.map((action) => (
          <Link
            key={action.id}
            to={action.to}
            className={`adm-kpi__quick-item is-${action.tone}`}
          >
            <span className="adm-kpi__quick-icon" aria-hidden>
              {action.icon}
            </span>
            <span>{action.label}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}

//Created By Cursor — collection/expense with today|yesterday breakdown toggle
function FinanceOpsPanel({ kpi, feePath, expensePath, admissionPath }) {
  const [breakDay, setBreakDay] = useState("today");
  const isYesterday = breakDay === "yesterday";
  const feeRows = isYesterday
    ? kpi.collection_by_fee_yesterday || []
    : kpi.collection_by_fee || [];
  const catRows = isYesterday
    ? kpi.expense_by_category_yesterday || []
    : kpi.expense_by_category || [];
  const dayLabel = isYesterday ? "Yesterday" : "Today";

  return (
    <div className="adm-kpi__finance-ops">
      <section className="adm-kpi__finance" aria-label="Collection and expense">
        <div className="adm-kpi__finance-head">
          <span className="adm-kpi__metric-icon" aria-hidden>
            <FaRupeeSign />
          </span>
          <div className="min-w-0">
            <h2>Collection &amp; expense</h2>
            <p>Today and yesterday</p>
          </div>
          <div className="adm-kpi__finance-links">
            <Link to={feePath} className="adm-kpi__link">
              Fees
            </Link>
            <Link to={expensePath} className="adm-kpi__link">
              Expense
            </Link>
          </div>
        </div>
        <div className="adm-kpi__finance-grid" role="group" aria-label="Select day for breakdowns">
          <button
            type="button"
            className={`adm-kpi__finance-cell is-in${breakDay === "today" ? " is-active" : ""}`}
            onClick={() => setBreakDay("today")}
          >
            <small>Collection · Today</small>
            <strong>₹{formatMoney(kpi.today_collection)}</strong>
            <em>{Number(kpi.today_collection_count || 0)} receipts</em>
          </button>
          <button
            type="button"
            className={`adm-kpi__finance-cell is-in${breakDay === "yesterday" ? " is-active" : ""}`}
            onClick={() => setBreakDay("yesterday")}
          >
            <small>Collection · Yesterday</small>
            <strong>₹{formatMoney(kpi.yesterday_collection)}</strong>
            <em>{Number(kpi.yesterday_collection_count || 0)} receipts</em>
          </button>
          <button
            type="button"
            className={`adm-kpi__finance-cell is-out${breakDay === "today" ? " is-active" : ""}`}
            onClick={() => setBreakDay("today")}
          >
            <small>Expense · Today</small>
            <strong>₹{formatMoney(kpi.today_expense)}</strong>
            <em>{Number(kpi.today_expense_count || 0)} entries</em>
          </button>
          <button
            type="button"
            className={`adm-kpi__finance-cell is-out${breakDay === "yesterday" ? " is-active" : ""}`}
            onClick={() => setBreakDay("yesterday")}
          >
            <small>Expense · Yesterday</small>
            <strong>₹{formatMoney(kpi.yesterday_expense)}</strong>
            <em>{Number(kpi.yesterday_expense_count || 0)} entries</em>
          </button>
        </div>

        <div className="adm-kpi__finance-splits">
          <div className="adm-kpi__fee-break">
            <div className="adm-kpi__split-head">
              <h3>Fee breakdown</h3>
              <span>{dayLabel}</span>
            </div>
            {feeRows.length > 0 ? (
              <div className="adm-kpi__fee-chips">
                {feeRows.slice(0, 6).map((fee, index) => (
                  <div className="adm-kpi__fee-chip" key={`${fee.fee_id || fee.fee_name}-${index}`}>
                    <span className="adm-kpi__fee-copy">
                      <small>{fee.fee_name || "Unknown Fee"}</small>
                      <strong>₹{formatMoney(fee.collection)}</strong>
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="adm-kpi__split-empty">No fee collection {isYesterday ? "yesterday" : "today"}</p>
            )}
          </div>

          <div className="adm-kpi__cat-break">
            <div className="adm-kpi__split-head">
              <h3>Category breakdown</h3>
              <span>{dayLabel}</span>
            </div>
            {catRows.length > 0 ? (
              <ul className="adm-kpi__cat-bars">
                {catRows.slice(0, 6).map((row) => (
                  <li key={row.category_name} className="adm-kpi__cat-bar">
                    <div className="adm-kpi__cat-meta">
                      <strong>{row.category_name}</strong>
                      <span>
                        ₹{formatMoney(row.amount)} · {Number(row.pct || 0)}%
                      </span>
                    </div>
                    <div className="adm-kpi__cat-track" aria-hidden>
                      <div
                        className="adm-kpi__cat-fill"
                        style={{ width: `${Math.min(100, Number(row.bar || 0))}%` }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="adm-kpi__split-empty">No expense categories {isYesterday ? "yesterday" : "today"}</p>
            )}
          </div>
        </div>
      </section>

      <section className="adm-kpi__ops" aria-label="Operations snapshot">
        <Link to="/AdminMain/AdmissionQuery" className="adm-kpi__ops-item">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaQuestionCircle />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>Admission enquiry</small>
            <strong>{Number(kpi.admission_enquiry || 0)}</strong>
          </span>
        </Link>
        <Link to={admissionPath} className="adm-kpi__ops-item">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaUserGraduate />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>New admissions this month</small>
            <strong>{Number(kpi.admission_month || 0)}</strong>
          </span>
        </Link>
        <Link to="/AdminMain/HomeworkAssign" className="adm-kpi__ops-item">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaBookOpen />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>Homework / assignment</small>
            <strong>{Number(kpi.homework_today || 0)}</strong>
            <em>Today</em>
          </span>
        </Link>
        <Link to="/AdminMain/AdminNotification" className="adm-kpi__ops-item">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaBell />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>Notifications sent</small>
            <strong>{Number(kpi.notifications_today || 0)}</strong>
            <em>Today</em>
          </span>
        </Link>
        <Link to="/AdminMain/WhatsAppQueue" className="adm-kpi__ops-item">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaWhatsapp />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>WhatsApp messages</small>
            <strong>{Number(kpi.whatsapp_today || 0)}</strong>
            <em>Today</em>
          </span>
        </Link>
        <div className="adm-kpi__ops-item is-static">
          <span className="adm-kpi__ops-icon" aria-hidden>
            <FaBirthdayCake />
          </span>
          <span className="adm-kpi__ops-copy">
            <small>Birthday today</small>
            <strong>{Number(kpi.birthday_today || 0)}</strong>
          </span>
        </div>
      </section>
    </div>
  );
}

//Created By Cursor — logs / calendar / actions / recommendations row
function DashInsightQuad({ kpi }) {
  const logs = Array.isArray(kpi?.activity_logs) ? kpi.activity_logs : [];
  const actions = Array.isArray(kpi?.action_required) ? kpi.action_required : [];
  const tips = Array.isArray(kpi?.recommendations) ? kpi.recommendations : [];

  return (
    <section className="adm-kpi__quad-card" aria-label="Dashboard insights">
      <div className="adm-kpi__quad">
        <section className="adm-kpi__quad-panel adm-kpi__quad-panel--logs">
          <div className="adm-kpi__quad-head">
            <span className="adm-kpi__quad-icon" aria-hidden>
              <FaHistory />
            </span>
            <div className="min-w-0">
              <h3>Activity logs</h3>
              <p>Change &amp; delete</p>
            </div>
            <span className="adm-kpi__quad-count">{logs.length}</span>
          </div>
          {logs.length > 0 ? (
            <ul className="adm-kpi__log-list">
              {logs.slice(0, 8).map((row, index) => (
                <li
                  key={`${row.log_type}-${row.log_id || index}`}
                  className={`adm-kpi__log-item is-${row.log_type || "change"}`}
                >
                  <span className="adm-kpi__log-type">
                    {row.log_type === "delete" ? "Delete" : "Change"}
                  </span>
                  <strong>{row.log_text || "Log entry"}</strong>
                  {row.detail ? (
                    <em>
                      {row.detail}
                      {row.old_value || row.new_value
                        ? `: ${row.old_value || "—"} → ${row.new_value || "—"}`
                        : ""}
                    </em>
                  ) : null}
                  <small>{formatLogWhen(row.date_added)}</small>
                </li>
              ))}
            </ul>
          ) : (
            <p className="adm-kpi__quad-empty">No recent change or delete logs</p>
          )}
        </section>

        <AdminDashCalendar
          birthdayCount={Number(kpi?.birthday_today || 0)}
          festivals={kpi?.festivals || []}
          holidays={kpi?.school_holidays || []}
        />

        <section className="adm-kpi__quad-panel adm-kpi__quad-panel--actions">
          <div className="adm-kpi__quad-head">
            <span className="adm-kpi__quad-icon" aria-hidden>
              <FaTasks />
            </span>
            <div className="min-w-0">
              <h3>Action required</h3>
              <p>Needs attention</p>
            </div>
            <span className="adm-kpi__quad-count">{actions.length}</span>
          </div>
          {actions.length > 0 ? (
            <ul className="adm-kpi__action-list">
              {actions.map((item) => {
                const body = (
                  <>
                    <span className={`adm-kpi__action-dot is-${item.tone || "info"}`} aria-hidden />
                    <span className="adm-kpi__action-copy">
                      <strong>{item.title}</strong>
                      <em>{item.detail}</em>
                    </span>
                  </>
                );
                return item.path ? (
                  <li key={item.id}>
                    <Link to={item.path} className="adm-kpi__action-item">
                      {body}
                    </Link>
                  </li>
                ) : (
                  <li key={item.id} className="adm-kpi__action-item is-static">
                    {body}
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="adm-kpi__quad-empty">Nothing pending right now</p>
          )}
        </section>

        <section className="adm-kpi__quad-panel adm-kpi__quad-panel--tips">
          <div className="adm-kpi__quad-head">
            <span className="adm-kpi__quad-icon" aria-hidden>
              <FaLightbulb />
            </span>
            <div className="min-w-0">
              <h3>Recommendations</h3>
              <p>Suggested next steps</p>
            </div>
            <span className="adm-kpi__quad-count">{tips.length}</span>
          </div>
          {tips.length > 0 ? (
            <ul className="adm-kpi__tip-list">
              {tips.map((item) => (
                <li key={item.id} className={`adm-kpi__tip-item is-${item.tone || "tip"}`}>
                  <FaExclamationCircle aria-hidden />
                  <span>
                    <strong>{item.title}</strong>
                    <em>{item.detail}</em>
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="adm-kpi__quad-empty">No recommendations yet</p>
          )}
        </section>
      </div>
    </section>
  );
}

//Created By Cursor
function formatLogWhen(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const d = new Date(raw.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

//Created By Cursor — compact month calendar with festivals/holidays
function AdminDashCalendar({
  birthdayCount = 0,
  festivals = [],
  holidays = [],
}) {
  const [viewMonth, setViewMonth] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const [selected, setSelected] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  });

  const todayStr = useMemo(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  }, []);

  const eventMap = useMemo(() => {
    const map = {};
    const push = (iso, item) => {
      if (!iso) return;
      if (!map[iso]) map[iso] = [];
      map[iso].push(item);
    };
    (festivals || []).forEach((f) => {
      const iso = String(f.date || "").slice(0, 10);
      push(iso, {
        kind: "festival",
        name: f.name || "Festival",
        publicHoliday: !!Number(f.is_public_holiday),
      });
    });
    (holidays || []).forEach((h) => {
      const start = String(h.start || "").slice(0, 10);
      const end = String(h.end || h.start || "").slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) return;
      const endIso = /^\d{4}-\d{2}-\d{2}$/.test(end) ? end : start;
      const cur = new Date(`${start}T00:00:00`);
      const last = new Date(`${endIso}T00:00:00`);
      if (Number.isNaN(cur.getTime()) || Number.isNaN(last.getTime())) return;
      while (cur <= last) {
        const iso = `${cur.getFullYear()}-${String(cur.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(cur.getDate()).padStart(2, "0")}`;
        push(iso, {
          kind: "holiday",
          name: h.name || "Holiday",
          publicHoliday: true,
        });
        cur.setDate(cur.getDate() + 1);
      }
    });
    return map;
  }, [festivals, holidays]);

  const days = useMemo(() => {
    const year = viewMonth.getFullYear();
    const month = viewMonth.getMonth();
    const firstDow = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const cells = [];
    for (let i = 0; i < firstDow; i += 1) cells.push(null);
    for (let day = 1; day <= daysInMonth; day += 1) {
      cells.push({
        day,
        iso: `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
      });
    }
    while (cells.length % 7 !== 0) cells.push(null);
    return cells;
  }, [viewMonth]);

  const monthEvents = useMemo(() => {
    const year = viewMonth.getFullYear();
    const month = viewMonth.getMonth();
    const prefix = `${year}-${String(month + 1).padStart(2, "0")}-`;
    const rows = [];
    Object.keys(eventMap)
      .filter((iso) => iso.startsWith(prefix))
      .sort()
      .forEach((iso) => {
        (eventMap[iso] || []).forEach((ev) => {
          rows.push({ iso, ...ev });
        });
      });
    return rows.slice(0, 6);
  }, [eventMap, viewMonth]);

  const selectedEvents = eventMap[selected] || [];
  const monthLabel = viewMonth.toLocaleString("en-IN", {
    month: "long",
    year: "numeric",
  });

  return (
    <section className="adm-kpi__quad-panel adm-kpi__cal" aria-label="Calendar">
      <div className="adm-kpi__quad-head">
        <span className="adm-kpi__quad-icon" aria-hidden>
          <FaCalendarAlt />
        </span>
        <div className="min-w-0">
          <h3>Calendar</h3>
          <p>{monthLabel}</p>
        </div>
        <div className="adm-kpi__cal-nav">
          <button
            type="button"
            className="adm-kpi__cal-nav-btn"
            aria-label="Previous month"
            onClick={() =>
              setViewMonth((m) => new Date(m.getFullYear(), m.getMonth() - 1, 1))
            }
          >
            <FaChevronLeft aria-hidden />
          </button>
          <button
            type="button"
            className="adm-kpi__cal-nav-btn"
            aria-label="Next month"
            onClick={() =>
              setViewMonth((m) => new Date(m.getFullYear(), m.getMonth() + 1, 1))
            }
          >
            <FaChevronRight aria-hidden />
          </button>
        </div>
      </div>
      <div className="adm-kpi__cal-week" aria-hidden>
        {["S", "M", "T", "W", "T", "F", "S"].map((w, i) => (
          <span key={`${w}-${i}`}>{w}</span>
        ))}
      </div>
      <div className="adm-kpi__cal-grid">
        {days.map((cell, index) => {
          if (!cell) {
            return <span key={`e-${index}`} className="adm-kpi__cal-day is-empty" />;
          }
          const isToday = cell.iso === todayStr;
          const isSelected = cell.iso === selected;
          const hasBday = isToday && birthdayCount > 0;
          const events = eventMap[cell.iso] || [];
          const hasFestival = events.some((e) => e.kind === "festival");
          const hasHoliday = events.some((e) => e.kind === "holiday" || e.publicHoliday);
          const title = [
            ...events.map((e) => e.name),
            hasBday ? `${birthdayCount} birthday(s)` : "",
          ]
            .filter(Boolean)
            .join(" · ");
          return (
            <button
              key={cell.iso}
              type="button"
              className={`adm-kpi__cal-day${isToday ? " is-today" : ""}${
                isSelected ? " is-selected" : ""
              }${hasBday ? " is-bday" : ""}${hasFestival ? " is-festival" : ""}${
                hasHoliday ? " is-holiday" : ""
              }`}
              onClick={() => setSelected(cell.iso)}
              title={title || cell.iso}
            >
              {cell.day}
              {hasFestival || hasHoliday ? (
                <i className={hasHoliday ? "is-hol" : "is-fest"} aria-hidden />
              ) : null}
              {hasBday ? <i className="is-cake" aria-hidden /> : null}
            </button>
          );
        })}
      </div>
      <div className="adm-kpi__cal-legend" aria-hidden>
        <span className="is-fest">Festival</span>
        <span className="is-hol">Holiday</span>
      </div>
      {selectedEvents.length > 0 ? (
        <ul className="adm-kpi__cal-events">
          {selectedEvents.slice(0, 3).map((ev, i) => (
            <li key={`${selected}-${ev.kind}-${i}`}>
              <strong>{ev.kind === "holiday" ? "Holiday" : "Festival"}</strong>
              <em>{ev.name}</em>
            </li>
          ))}
        </ul>
      ) : monthEvents.length > 0 ? (
        <ul className="adm-kpi__cal-events">
          {monthEvents.map((ev, i) => (
            <li key={`${ev.iso}-${ev.kind}-${i}`}>
              <strong>{Number(String(ev.iso).slice(-2))}</strong>
              <em>{ev.name}</em>
            </li>
          ))}
        </ul>
      ) : (
        <p className="adm-kpi__cal-note is-muted">No festivals this month</p>
      )}
      {birthdayCount > 0 ? (
        <p className="adm-kpi__cal-note">
          <FaBirthdayCake aria-hidden /> {birthdayCount} birthday
          {birthdayCount === 1 ? "" : "s"} today
        </p>
      ) : null}
    </section>
  );
}

//Created By Cursor
function AnnouncementPanel({ items }) {
  if (!items?.length) return null;

  return (
    <section className="adm-announce" aria-label="Announcements">
      <div className="adm-announce__head">
        <FaBullhorn aria-hidden />
        <h2>Announcement</h2>
      </div>
      <div className="adm-announce__list">
        {items.map((item, index) => {
          const title = String(item?.announcement_title || "").trim();
          const body = String(item?.announcement || "").trim();
          const img = String(item?.img_path || "").trim();
          return (
            <article
              key={`announce-${index}-${title || body.slice(0, 24)}`}
              className={
                img
                  ? "adm-announce__card adm-announce__card--media"
                  : "adm-announce__card"
              }
            >
              {img ? (
                <div className="adm-announce__media">
                  <img src={img} alt="" />
                </div>
              ) : null}
              <div className="adm-announce__copy">
                {title ? <h3>{title}</h3> : null}
                {body ? (
                  <div
                    className="adm-announce__html"
                    dangerouslySetInnerHTML={{ __html: body }}
                  />
                ) : null}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

//Created By Cursor
function ModuleTile({ to, title, iconImg, index = 0, tone = "erp" }) {
  return (
    <Link
      to={to}
      className={`adm-tile adm-tile--${tone}`}
      style={{ "--adm-i": index }}
      aria-label={title}
      title={title}
    >
      <span className="adm-tile__icon" aria-hidden>
        {iconImg ? (
          <img src={iconImg} alt="" />
        ) : (
          <FaThLarge className="adm-tile__fallback" />
        )}
      </span>
      <span className="adm-tile__title">{title}</span>
    </Link>
  );
}

//Created By Cursor
function ModuleSection({ title, subtitle, items, tone, buildTo, card = false }) {
  const head = (
    <div className="adm-section__head">
      <div>
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
    </div>
  );

  const body = !items?.length ? (
    <div className="adm-empty">
      <p>No modules in this section.</p>
    </div>
  ) : (
    <div className="adm-grid">
      {items.map((item, index) => (
        <ModuleTile
          key={`${item.module_id || item.component_name || title}-${index}`}
          to={buildTo(item)}
          title={item.module_name || "Module"}
          iconImg={item.icon_img}
          index={index}
          tone={tone}
        />
      ))}
    </div>
  );

  if (card) {
    return (
      <section className="adm-section">
        {head}
        <div className="adm-section__card">{body}</div>
      </section>
    );
  }

  return (
    <section className="adm-section">
      {head}
      {body}
    </section>
  );
}

function AdminMain() {
  const history = useHistory();
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loginType, setLoginType] = useState("");
  const [adminModules, setAdminModules] = useState([]);
  const [allActiveModulesOfClerk, setAllActiveModulesOfClerk] = useState([]);
  const [mModuleLMS, setMModuleLMS] = useState([]);
  const [mModuleERP, setMModuleERP] = useState([]);
  const [mCurrentSession, setMCurrentSession] = useState([]);
  const [mProductAccount, setMProductAccount] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [dashboardKpi, setDashboardKpi] = useState(null);
  const [accessGate, setAccessGate] = useState({
    allow: true,
    reason: null,
    demoDays: null,
    status: "",
    statusName: "",
  });
  const [refreshing, setRefreshing] = useState(false);
  const [showStudentSearch, setShowStudentSearch] = useState(false);
  const [classAttDate, setClassAttDate] = useState("");
  const [classAttLoading, setClassAttLoading] = useState(false);

  const getAllActiveClerkModules = useCallback((modules = null) => {
    const modulesToFilter = modules || allActiveModulesOfClerk || [];
    const erpModules = modulesToFilter.filter(
      (module) => module?.software_section === "ERP"
    );
    setMModuleERP(erpModules);
  }, [allActiveModulesOfClerk]);

  const getLmsModules = useCallback((modules = null) => {
    const modulesToFilter = modules || allActiveModulesOfClerk || [];
    const lmsModules = modulesToFilter.filter(
      (module) => module?.software_section === "LMS"
    );
    setMModuleLMS(lmsModules);
  }, [allActiveModulesOfClerk]);

  const getAdminDashboard = useCallback((opts = {}) => {
    const soft = Boolean(opts.soft);
    if (!soft) setLoading(true);

    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      console.error("School code not found");
      myToast.notify_error("School code is missing. Please login again.");
      setLoading(false);
      setRefreshing(false);
      setLoggedIn(false);
      return;
    }

    const FUNCTION_NAME = "getAdminMainDashboard.php?";
    const systemCode = process.env.REACT_APP_SYSTEM_CODE;
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: schoolCode,
      system_code: systemCode,
      CurrentVersionCode: "1.1",
      lite: "1",
    };
    const kpiOnly = Boolean(opts.kpi_only);
    if (kpiOnly) {
      params.kpi_only = "1";
    }
    if (opts.attendance_date) {
      params.attendance_date = opts.attendance_date;
    }

    //Created By Cursor
    const queryString = new URLSearchParams(params).toString();
    console.log("AdminMain:getAdminDashboard -> URL:", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        setRefreshing(false);
        setClassAttLoading(false);

        const apiStatus = response?.api_status;

        if (apiStatus === "OK") {
          const dashboard = response.dashboard || {};

          //Created By Cursor — kpi_only soft refresh: update KPI (+ session) without wiping modules
          if (kpiOnly) {
            const kpiPayload = dashboard.kpi || null;
            const currentSession = dashboard.CurrentSession || [];
            if (currentSession.length) {
              setMCurrentSession(currentSession);
              SessionManager.saveCurrentSession(currentSession);
            }
            if (kpiPayload) {
              if (
                !Number(kpiPayload.total_student) &&
                currentSession?.[0]?.total_student != null
              ) {
                kpiPayload.total_student =
                  Number(currentSession[0].total_student) || 0;
              }
              setDashboardKpi((prev) => {
                if (!prev) return kpiPayload;
                //Created By Cursor — keep selected-date class chart if user changed date
                if (classAttDate && prev.class_attendance) {
                  return {
                    ...prev,
                    ...kpiPayload,
                    class_attendance: prev.class_attendance,
                  };
                }
                return { ...prev, ...kpiPayload };
              });
            }
            return;
          }

          const adminModulesData = dashboard.AdminModules || [];
          const clerkModules = dashboard.ClerkAllActiveModules || [];
          const currentSession = dashboard.CurrentSession || [];
          const productAccount = dashboard.product_account || [];
          const schoolInfo = Array.isArray(dashboard.SchoolDetails)
            ? dashboard.SchoolDetails[0] || null
            : dashboard.SchoolDetails || null;
          const announcementList = Array.isArray(dashboard.Announcement)
            ? dashboard.Announcement
            : [];

          setAdminModules(adminModulesData);
          setAllActiveModulesOfClerk(clerkModules);
          setMCurrentSession(currentSession);
          setMProductAccount(productAccount);
          setSchoolDetails(schoolInfo);
          setAnnouncements(announcementList);
          const kpiPayload = dashboard.kpi || null;
          if (
            kpiPayload &&
            !Number(kpiPayload.total_student) &&
            currentSession?.[0]?.total_student != null
          ) {
            kpiPayload.total_student = Number(currentSession[0].total_student) || 0;
          }
          setDashboardKpi(kpiPayload);
          if (!kpiPayload) {
            console.warn("AdminMain: dashboard.kpi missing from API response");
          }

          SessionManager.saveCurrentSession(currentSession);

          const access = resolveProductAccess(productAccount);
          setAccessGate(access);
          if (!access.allow) {
            return;
          }

          getAllActiveClerkModules(clerkModules);
          getLmsModules(clerkModules);
        } else {
          const apiRemark = response?.api_remark || "Failed to load dashboard";
          myToast.notify_warning(apiRemark);
        }
      })
      .catch((error) => {
        console.error("Admin dashboard error:", error);
        setLoading(false);
        setRefreshing(false);
        setClassAttLoading(false);

        let errorMessage = "Network error. Please check your connection.";
        if (error.response) {
          errorMessage = error.response.data?.api_remark || `Server error: ${error.response.status}`;
        } else if (error.request) {
          errorMessage = "No response from server. Please try again.";
        }

        myToast.notify_error(errorMessage);
      });
  }, [getAllActiveClerkModules, getLmsModules, classAttDate]);

  //Created By Cursor — class attendance date via dashboard att_only (no separate endpoint)
  const fetchClassAttendanceByDate = useCallback((date) => {
    const next = String(date || "").trim();
    if (!next) return;

    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      myToast.notify_error("School code is missing. Please login again.");
      return;
    }

    setClassAttLoading(true);
    const FUNCTION_NAME = "getAdminMainDashboard.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: schoolCode,
      system_code: process.env.REACT_APP_SYSTEM_CODE,
      CurrentVersionCode: "1.1",
      lite: "1",
      att_only: "1",
      attendance_date: next,
    };

    //Created By Cursor
    const queryString = new URLSearchParams(params).toString();
    console.log(
      "AdminMain:getAdminDashboard(att_only) -> URL:",
      `${URL}${queryString}`
    );

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setClassAttLoading(false);
        if (response?.api_status === "OK") {
          const ca = response.dashboard?.kpi?.class_attendance;
          if (ca) {
            setDashboardKpi((prev) =>
              prev
                ? { ...prev, class_attendance: ca }
                : { class_attendance: ca }
            );
          }
        } else {
          myToast.notify_warning(
            response?.api_remark || "Failed to load class attendance"
          );
        }
      })
      .catch((error) => {
        console.error("Class attendance by date error:", error);
        setClassAttLoading(false);
        myToast.notify_error("Network error loading class attendance.");
      });
  }, []);

  const getClerkDashboard = useCallback(() => {
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      console.error("School code not found");
      myToast.notify_error("School code is missing. Please login again.");
      setLoggedIn(false);
      return;
    }

    const mStaffData = SessionManager.getStaffDetails();
    if (!mStaffData || !mStaffData.staff_id) {
      console.error("Staff data not found");
      myToast.notify_error("Staff information is missing. Please login again.");
      setLoggedIn(false);
      return;
    }

    const staffId = mStaffData.staff_id;
    const systemCode = process.env.REACT_APP_SYSTEM_CODE;
    const FUNCTION_NAME = "getDashBoard.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: schoolCode,
      staff_id: staffId,
      system_code: systemCode,
      CurrentVersionCode: "1.1",
    };
    const queryString = new URLSearchParams(params).toString();
    console.log("AdminMain:getClerkDashboard -> URL:", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setRefreshing(false);
        const apiStatus = response?.api_status;
        
        if (apiStatus === "OK") {
          const dashboard = response.dashboard || {};
          const currentSession = dashboard.CurrentSession || [];
          const privileges = dashboard.privilege || [];
          const productAccount = dashboard.product_account || [];
          const schoolInfo = Array.isArray(dashboard.SchoolDetails)
            ? dashboard.SchoolDetails[0] || null
            : dashboard.SchoolDetails || null;
          const announcementList = Array.isArray(dashboard.Announcement)
            ? dashboard.Announcement
            : [];

          setMCurrentSession(currentSession);
          setAllActiveModulesOfClerk(privileges);
          setMProductAccount(productAccount);
          setSchoolDetails(schoolInfo);
          setAnnouncements(announcementList);
          const kpiPayload = dashboard.kpi || null;
          if (
            kpiPayload &&
            !Number(kpiPayload.total_student) &&
            currentSession?.[0]?.total_student != null
          ) {
            kpiPayload.total_student = Number(currentSession[0].total_student) || 0;
          }
          setDashboardKpi(kpiPayload);
          if (!kpiPayload) {
            console.warn("AdminMain: clerk dashboard.kpi missing from API response");
          }

          SessionManager.saveCurrentSession(currentSession);

          const access = resolveProductAccess(productAccount);
          setAccessGate(access);
          if (!access.allow) {
            return;
          }

          getAllActiveClerkModules(privileges);
          getLmsModules(privileges);
        } else {
          const apiRemark = response?.api_remark || "Failed to load dashboard";
          myToast.notify_warning(apiRemark);
        }
      })
      .catch((error) => {
        console.error("Clerk dashboard error:", error);
        setRefreshing(false);
        
        let errorMessage = "Network error. Please check your connection.";
        if (error.response) {
          errorMessage = error.response.data?.api_remark || `Server error: ${error.response.status}`;
        } else if (error.request) {
          errorMessage = "No response from server. Please try again.";
        }
        
        myToast.notify_error(errorMessage);
      });
  }, [getAllActiveClerkModules, getLmsModules]);

  // useEffect for componentDidMount
  useEffect(() => {
    const token = localStorage.getItem("token"); 
    if (token) {
      try {   
        const decoded = jwtDecode(token);
        const isExpired = decoded.exp * 1000 < Date.now();
        if (isExpired) {
          localStorage.removeItem("token");
          setLoggedIn(false);
          console.log("AdminMain useEffect: token expired, redirecting to login");
          return;
        }
      } catch (error) {
        // Token is invalid or malformed
        console.error("AdminMain useEffect: token decode error:", error);
        localStorage.removeItem("token");
        setLoggedIn(false);
        return;
      }
    } else {
      console.log("AdminMain useEffect: no token found, redirecting to login");
      setLoggedIn(false);
      return;
    }

    const mStaffData = SessionManager.getStaffDetails();
    if (!mStaffData || !mStaffData.login_type) {
      console.error("Staff data not found");
      setLoggedIn(false);
      return;
    }

    const loginTypeValue = mStaffData.login_type;
    
    setLoginType(loginTypeValue);

    if (loginTypeValue === process.env.REACT_APP_LOGIN_TYPE_ADMIN) {
      
      getAdminDashboard();
    } else if (loginTypeValue === process.env.REACT_APP_LOGIN_TYPE_CLERK) {
      
      getClerkDashboard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Created By Cursor
  const refreshDashboard = useCallback(() => {
    setRefreshing(true);
    if (loginType === process.env.REACT_APP_LOGIN_TYPE_ADMIN) {
      getAdminDashboard({ soft: true, kpi_only: true });
      if (classAttDate) {
        fetchClassAttendanceByDate(classAttDate);
      }
    } else if (loginType === process.env.REACT_APP_LOGIN_TYPE_CLERK) {
      getClerkDashboard();
    } else {
      setRefreshing(false);
    }
  }, [
    loginType,
    getAdminDashboard,
    getClerkDashboard,
    classAttDate,
    fetchClassAttendanceByDate,
  ]);

  //Created By Cursor
  const handleClassAttDateChange = useCallback(
    (date) => {
      const next = String(date || "").trim();
      if (!next) return;
      setClassAttDate(next);
      fetchClassAttendanceByDate(next);
    },
    [fetchClassAttendanceByDate]
  );

  //Created By Cursor
  const openStudentSearch = useCallback(() => {
    setShowStudentSearch(true);
  }, []);

  //Created By Cursor
  const closeStudentSearch = useCallback(() => {
    setShowStudentSearch(false);
  }, []);

  //Created By Cursor
  const handleStudentSearchDone = useCallback(
    (studentId, selectedItem, sessionId) => {
      setShowStudentSearch(false);
      const sid = String(studentId || "").trim();
      if (!sid) {
        myToast.notify_warning("Student not found.");
        return;
      }
      const sess =
        String(sessionId || "").trim() ||
        String(selectedItem?.class?.[0]?.session_id || "").trim() ||
        String(mCurrentSession?.[0]?.session_id || "").trim();
      if (!sess) {
        myToast.notify_warning("Session not found for this student.");
        return;
      }
      history.push(`/AdminMain/StudentDetails/${sid}/${sess}`);
    },
    [history, mCurrentSession]
  );

  if (loggedIn === false) {
    return <Redirect to="/" />;
  }
  if (loading) {
    return <MyLoader />;
  }

  const schoolCode =
    schoolDetails?.school_code || SessionManager.getSchoolCode() || "";
  const schoolName = String(schoolDetails?.school_name || "").trim();
  const schoolAddress = String(schoolDetails?.school_address || "").trim();
  const heroTitle = schoolName
    ? schoolCode
      ? `${schoolName} (${schoolCode})`
      : schoolName
    : "Admin dashboard";
  const demoDaysLeft =
    accessGate?.allow &&
    accessGate?.status === "1" &&
    accessGate?.demoDays != null
      ? Number(accessGate.demoDays)
      : null;
  //Created By Cursor — service ended but still inside subscription grace
  const graceDaysLeft =
    accessGate?.allow &&
    accessGate?.inGrace &&
    accessGate?.graceDays != null
      ? Number(accessGate.graceDays)
      : null;

  if (accessGate && accessGate.allow === false) {
    return (
      <AccountAccessBlock
        reason={accessGate.reason || "service_expired"}
        schoolName={schoolName}
        schoolCode={schoolCode}
        productStatusName={accessGate.statusName || ""}
      />
    );
  }

      return (
        <div>
          <NavMenuAdmin />
          <AiAssistant />
          <Switch>
              <Route
                path="/AdminMain"
                exact
                render={() => {
                  return (
                    <div
                      className="content payroll-page sm-page adm-page"
                      style={{ background: COLORS.white, fontFamily: PAGE_FONT }}
                    >
                      <div
                        className="content-header"
                        style={{ background: COLORS.primary_color_shade5 }}
                      >
                        <div className="leftside-content-header">
                          <ul className="breadcrumbs">
                            <li>
                              <i
                                className="fa fa-home"
                                aria-hidden="true"
                                style={{ color: COLORS.white }}
                              />
                              <span style={{ color: COLORS.white }}>
                                {" "}
                                Admin dashboard
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="row animated fadeInUp">
                        <div className="col-sm-12">
                          <div className="sm-shell adm-shell">
                            <header
                              className="sm-hero"
                              style={{ background: HERO_GRADIENT }}
                            >
                              <div className="sm-hero__copy">
                                <h1 className="sm-hero__title">{heroTitle}</h1>
                                {schoolAddress ? (
                                  <p className="sm-hero__sub">{schoolAddress}</p>
                                ) : null}
                                <p className="sm-hero__sub adm-hero-label">
                                  Dashboard
                                </p>
                              </div>
                              <div className="sm-hero__tools">
                                {demoDaysLeft != null ? (
                                  <span className="adm-hero-demo">
                                    {demoDaysLeft <= 1
                                      ? "Demo expires today"
                                      : `Demo · ${demoDaysLeft} days left`}
                                  </span>
                                ) : null}
                                {graceDaysLeft != null ? (
                                  <span className="adm-hero-demo">
                                    {graceDaysLeft <= 1
                                      ? "Grace ends today — renew soon"
                                      : `Grace · ${graceDaysLeft} days left`}
                                  </span>
                                ) : null}
                                <button
                                  type="button"
                                  className="sr-btn sr-btn--ghost adm-hero-search"
                                  style={{
                                    color: "#01579b",
                                    background: "#fff",
                                    borderColor: "rgba(255,255,255,0.55)",
                                  }}
                                  onClick={openStudentSearch}
                                  aria-label="Search student"
                                >
                                  <FaSearch aria-hidden />
                                  <span>Search student</span>
                                </button>
                                <button
                                  type="button"
                                  className="sr-btn sr-btn--ghost"
                                  style={{
                                    color: "#01579b",
                                    background: "#fff",
                                    borderColor: "rgba(255,255,255,0.55)",
                                  }}
                                  disabled={refreshing}
                                  onClick={refreshDashboard}
                                  aria-label="Refresh dashboard"
                                >
                                  <FaSyncAlt
                                    aria-hidden
                                    className={
                                      refreshing ? "adm-refresh-spin" : undefined
                                    }
                                  />
                                  <span>Refresh</span>
                                </button>
                              </div>
                            </header>

                            {showStudentSearch ? (
                              <MdlSearchStudent
                                actionClose={closeStudentSearch}
                                actionDone={handleStudentSearchDone}
                              />
                            ) : null}

                            <div className="sr-body adm-body">
                              <DashboardKpiPanel
                                kpi={dashboardKpi}
                                modules={mModuleERP}
                                announcements={announcements}
                                classAttLoading={classAttLoading}
                                onClassAttDateChange={handleClassAttDateChange}
                              />

                              {loginType ===
                              process.env.REACT_APP_LOGIN_TYPE_ADMIN ? (
                                <ModuleSection
                                  title="Super Admin modules"
                                  items={adminModules}
                                  tone="admin"
                                  card
                                  buildTo={(item) =>
                                    `/AdminMain/${item.component_name}`
                                  }
                                />
                              ) : null}

                              <ModuleSection
                                title="Admin / modules"
                                subtitle="Day-to-day ERP operations"
                                items={mModuleERP}
                                tone="admin"
                                card
                                buildTo={(item) =>
                                  `/AdminMain/${item.component_name}/${item.module_id}`
                                }
                              />

                              <ModuleSection
                                title="Learning Management"
                                subtitle="LMS teaching & learning tools"
                                items={mModuleLMS}
                                tone="lms"
                                buildTo={(item) =>
                                  `/AdminMain/${item.component_name}/${item.module_id}`
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }}
              />

              <Route path="/AdminMain/ModuleList" component={ModuleList} />
              <Route
                path="/AdminMain/StaffPrivilege"
                component={StaffPrivilege}
              />
              <Route path="/AdminMain/Security" component={Security} />
              <Route path="/AdminMain/Settlement" component={Settlement} />
              <Route
                path="/AdminMain/SettlementFeeAdvance"
                component={SettlementFeeAdvance}
              />
              <Route
                path="/AdminMain/ViewSettlement"
                component={ViewSettlement}
              />
              <Route path="/AdminMain/HelpDesk" component={HelpDesk} />
              <Route path="/AdminMain/SupportChat" component={SupportChat} />
              <Route path="/AdminMain/Comment" component={Comment} />
              <Route
                path="/AdminMain/AdminNotification"
                component={AdminNotification}
              />
              <Route
                path="/AdminMain/RevenueManagement"
                component={RevenueManagement}
              />
              <Route
                path="/AdminMain/ManageRecords"
                component={ManageRecords}
              />
              <Route
                path="/AdminMain/LeaveManagementAdmin"
                component={LeaveManagementAdmin}
              />
              <Route
                path="/AdminMain/StaffList/:module_id"
                component={StaffList}
              />
              <Route
                path="/AdminMain/PayRollStaffList"
                exact
                component={PayRollStaffList}
              />
              <Route
                path="/AdminMain/PayRollStaffDetail/:staff_id"
                exact
                component={PayRollStaffDetail}
              />
              <Route
                path="/AdminMain/PayRollAddStaff"
                component={PayRollAddStaff}
              />
              <Route
                path="/AdminMain/PayRollSettings"
                component={PayRollSettings}
              />
              <Route
                path="/AdminMain/PayRollAddSalary"
                component={PayRollAddSalary}
              />
              <Route
                path="/AdminMain/PayRollSalaryDetails/:salary_id"
                component={PayRollSalaryDetails}
              />
              <Route
                path="/AdminMain/PayRollStaffDetails/:salary_id"
                render={({ match, location }) => (
                  <Redirect
                    to={{
                      pathname: `/AdminMain/PayRollSalaryDetails/${match.params.salary_id}`,
                      search: location.search,
                      state: location.state,
                    }}
                  />
                )}
              />
              <Route
                path="/AdminMain/PayRollPayslip/:salary_id/:session_id"
                component={PayRollPayslip}
              />
              <Route
                path="/AdminMain/PayRoll/:module_id"
                component={PayRoll}
              />
              <Route
                path="/AdminMain/Settings"
                component={Settings}
              />
              <Route
                path="/AdminMain/FineSettings"
                component={FineSettings}
              />
              <Route
                path="/AdminMain/ReportManagement"
                component={ReportManagement}
              />
              <Route
                path="/AdminMain/StudentManagement"
                component={StudentManagement}
              />
              <Route
                path="/AdminMain/StaffManagement"
                component={StaffManagement}
              />
              <Route
                path="/AdminMain/StaffSubject"
                exact
                component={StaffSubject}
              />
              <Route
                path="/AdminMain/StaffSubject/:staff_id"
                component={StaffSubject}
              />
              {/* Created By Cursor */}
              <Route path="/AdminMain/LessonPlan" exact component={LessonPlan} />
              <Route
                path="/AdminMain/LessonPlan/new"
                exact
                component={LessonPlanEditor}
              />
              <Route
                path="/AdminMain/LessonPlan/:plan_id"
                component={LessonPlanEditor}
              />
              <Route
                path="/AdminMain/ActivityManagement"
                exact
                component={ActivityManagement}
              />
              <Route
                path="/AdminMain/StaffAttendanceDash"
                component={StaffAttendanceDash}
              />
              <Route
                path="/AdminMain/StaffMonthAttendance"
                component={StaffMonthAttendance}
              />
              <Route
                path="/AdminMain/StaffAttendance"
                exact
                component={StaffAttendance}
              />
              <Route
                path="/AdminMain/StaffAttendanceDetail/:staff_id/:staff_name"
                component={StaffAttendanceDetail}
              />
              <Route
                path="/AdminMain/StaffBiometricId"
                component={StaffBiometricId}
              />

              <Route
                path="/AdminMain/UpdateSchoolDetails"
                component={UpdateSchoolDetails}
              />
              {/* Created By Cursor — multi affiliation manager */}
              <Route
                exact
                path="/AdminMain/SchoolAffiliations"
                component={SchoolAffiliations}
              />
              {/* Created By Cursor — support /SchoolProfile and /SchoolProfile/:module_id */}
              <Route
                exact
                path="/AdminMain/SchoolProfile"
                component={SchoolProfile}
              />
              <Route
                exact
                path="/AdminMain/SchoolProfile/:module_id"
                component={SchoolProfile}
              />
              <Route
                path="/AdminMain/FeeDashBoard/:module_id"
                component={FeeDashBoard}
              />
              <Route
                path="/AdminMain/AdmissionDashboard/:module_id"
                component={AdmissionDashboard}
              />
              <Route
                path="/AdminMain/AttendanceDashboard/:module_id"
                component={AttendanceDashboard}
              />
              <Route
                path="/AdminMain/TodayAttendance/:class_id/:section_id/:class_name/:section_name"
                component={TodayAttendance}
              />
              <Route
                path="/AdminMain/ClassList/:module_id"
                component={ClassList}
              />
              <Route
                path="/AdminMain/NoticeBoard/:module_id"
                component={NoticeBoard}
              />
              <Route path="/AdminMain/Holiday/:module_id" component={Holiday} />
              <Route path="/AdminMain/HomeWork" component={HomeWork} />
              <Route
                path="/AdminMain/HomeworkAssign"
                component={HomeworkAssign}
              />
              <Route
                path="/AdminMain/AssignHomework"
                component={HomeworkAssign}
              />
              <Route
                path="/AdminMain/Transport/:module_id"
                component={Transport}
              />
              <Route
                path="/AdminMain/Academic/:module_id"
                component={Academic}
              />
              <Route
                path="/AdminMain/HostelManagement/:module_id"
                component={HostelManagement}
              />
              <Route
                path="/AdminMain/HostelStudent"
                component={HostelStudent}
              />
              <Route
                path="/AdminMain/HostelStudentDetails/:student_id/:class_id/:session_id/:service_id"
                component={HostelStudentDetails}
              />
              <Route
                path="/AdminMain/AddHostelStudent"
                component={AddHostelStudent}
              />
              <Route
                path="/AdminMain/Notification/:module_id"
                component={Notification}
              />
              <Route
                exact
                path="/AdminMain/MyProfile"
                component={MyProfile}
              />
              <Route
                path="/AdminMain/MyProfile/:module_id"
                component={MyProfile}
              />
               <Route
                path="/AdminMain/ExpenseManager/:module_id"
                component={ExpenseManager}
              />
              <Route
                path="/AdminMain/ExpenseList"
                component={ExpenseList}
              />
              <Route
                path="/AdminMain/ExpenseReport"
                component={ExpenseReport}
              />
              <Route
                path="/AdminMain/StatementManager/:document_type?"
                component={StatementManager}
              />
              <Route
                path="/AdminMain/LeaveManagement"
                component={LeaveManagement}
              />
              <Route
                path="/AdminMain/LearningManagement"
                component={LearningManagement}
              />
              <Route
                path="/AdminMain/Accessories/:module_id"
                component={Accessories}
              />
              <Route path="/AdminMain/DataCenter" component={DataCenter} />
              <Route
                path="/AdminMain/TransactionPanel/:module_id"
                component={TransactionPanel}
              />
              <Route
                path="/AdminMain/PrintMaster/:module_id"
                component={PrintMaster}
              />

              <Route
                path="/AdminMain/StudentList/:class_id/:section_id/:session_id"
                component={StudentList}
              />
              <Route
                path="/AdminMain/StudentDetails/:student_id/:session_id"
                component={StudentDetails}
              />

              <Route
                path="/AdminMain/PaymentStatus/:student_id/:session_id/:session_name/:transaction_id"
                component={PaymentStatus}
              />
              <Route
                path="/AdminMain/AdvancedPayment/:student_id/:session_id/:current_due"
                component={AdvancedPayment}
              />
              <Route
                path="/AdminMain/PaymentHistory/:student_id/:session_id/:session_name"
                component={PaymentHistory}
              />
              <Route
                path="/AdminMain/FeeCard/:enrollment_no?/:session_id?"
                component={FeeCard}
              />
              <Route
                path="/AdminMain/PaymentDetails/:transaction_id/:session_id/:student_id/:transaction_for"
                component={PaymentDetails}
              />

              <Route
                path="/AdminMain/FeeReceipt/:transaction_id/:student_id/:session_id"
                component={FeeReceipt}
              />

              <Route
                path="/AdminMain/FeeCollection"
                component={FeeCollection}
              />
              <Route path="/AdminMain/CurrentDue" component={CurrentDue} />
              <Route
                path="/AdminMain/TotalRecieved"
                component={TotalRecieved}
              />
              <Route path="/AdminMain/TotalDue" component={TotalDue} />
              <Route path="/AdminMain/TotalFee" component={TotalFee} />
              <Route path="/AdminMain/TotalSettled" component={TotalSettled} />
              <Route
                path="/AdminMain/FeeStructureManager"
                component={FeeStructureManager}
              />
              <Route path="/AdminMain/OldDueList/:tag" component={OldDueList} />

              <Route
                path="/AdminMain/StudentRegistration"
                component={StudentRegistration}
              />
              <Route path="/AdminMain/AddHoliday" component={AddHoliday} />
              <Route
                path="/AdminMain/PromoteStudent"
                component={PromoteStudent}
              />
              <Route path="/AdminMain/EditStaff" component={EditStaff} />
              <Route
                path="/AdminMain/StaffRegistration"
                component={StaffRegistration}
              />
              <Route
                path="/AdminMain/UpdateStudentDetails"
                component={UpdateStudentDetails}
              />

              <Route path="/AdminMain/ManageNotice" component={ManageNotice} />
              <Route path="/AdminMain/AddNotice" component={AddNotice} />
              <Route
                path="/AdminMain/SendNotification"
                component={SendNotification}
              />
              <Route
                path="/AdminMain/Acknowledgement/:student_id/:Session_id"
                component={Acknowledgement}
              />
              <Route
                path="/AdminMain/AdmissionForm/:student_id/:Session_id"
                component={AdmissionForm}
              />
              <Route
                path="/AdminMain/StudentRegSuccess/:Enrollment_no/:session_id"
                component={StRegSuccessfull}
              />

              <Route path="/AdminMain/ExamList" component={ExamList} />
              <Route path="/AdminMain/ClassTestList" component={ClassTestList} />
              <Route
                path="/AdminMain/TestScore"
                exact
                component={TestScore}
              />
              <Route
                path="/AdminMain/FeeOtherAmount"
                component={FeeOtherAmount}
              />

              <Route
                path="/AdminMain/ClassSettings"
                component={ClassSettings}
              />
              <Route path="/AdminMain/ClassFee" component={ClassFee} />
              <Route
                path="/AdminMain/AddClassFee/:selected_class_pos"
                component={AddClassFee}
              />
              <Route path="/AdminMain/FeeNameList" component={FeeNameList} />
              <Route
                path="/AdminMain/SpecialCaseStudent"
                component={SpecialCaseStudent}
              />
              <Route
                path="/AdminMain/SpecialCaseCreation"
                component={SpecialCaseCreation}
              />
              <Route
                path="/AdminMain/RteStudent"
                component={RteStudent}
              />
              <Route
                path="/AdminMain/RteCreation"
                component={RteCreation}
              />
              <Route
                path="/AdminMain/AdmissionQuery"
                component={AdmissionQuery}
              />
              <Route
                path="/AdminMain/AdmissionQueryDetails/:request_id"
                component={AdmissionQueryDetails}
              />
              <Route
                path="/AdminMain/AdmissionLink"
                component={AdmissionLink}
              />
              <Route
                path="/AdminMain/RegistrationFee"
                component={RegistrationFee}
              />
              <Route path="/AdminMain/MyVendor" component={MyVendor} />
              <Route
                path="/AdminMain/VendorRegistration"
                component={VendorRegistration}
              />
              <Route
                path="/AdminMain/ExamTopperList"
                component={ExamTopperList}
              />
              <Route
                path="/AdminMain/ExamPaperSettings/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamPaperSettings}
              />
              <Route
                path="/AdminMain/ExamClassResultStatus/:exam_id/:session_id/:exam_name/:exam_date"
                component={ExamClassResultStatus}
              />
              <Route
                path="/AdminMain/ExamDetails/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamDetails}
              />
              <Route
                path="/AdminMain/ExamClassResult/:exam_id/:session_id/:selected_position_class/:selected_position_subject/:exam_name/:exam_date"
                component={ExamClassResult}
              />
              <Route
                path="/AdminMain/ExamStudentResult/:exam_id/:session_id/:student_id/:class_id/:section_id/:exam_name/:exam_date"
                component={ExamStudentResult}
              />
              <Route
                path="/AdminMain/ExamStudentReportCard/:report_card_id/:exam_id/:session_id/:student_id"
                render={(props) => (
                  <ExamStudentReportCard
                    key={props.match.url}
                    {...props}
                  />
                )}
              />
              <Route
                path="/AdminMain/ManageManualAttendance"
                component={ManageManualAttendance}
              />
              <Route
                path="/AdminMain/ExamReportCardList"
                exact
                component={ExamReportCardList}
              />

              <Route
                path="/AdminMain/StudentIdCard/:student_id/:session_id"
                component={StudentIdCard}
              />
              <Route
                path="/AdminMain/StudentIdCard"
                exact
                component={StudentIdCard}
              />
              <Route
                path="/AdminMain/ExamAdmitCard/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamAdmitCard}
              />
              <Route
                path="/AdminMain/ExamDateSheet/:exam_id/:session_id/:exam_name/exam_status"
                component={ExamDateSheet}
              />
              <Route
                path="/AdminMain/ExamGuideline/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamGuideline}
              />
              <Route
                path="/AdminMain/ExamHallTicket/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamHallTicket}
              />
              <Route
                path="/AdminMain/ReportViewClass/:document_type/"
                component={ReportViewClass}
              />
              <Route
                path="/AdminMain/StudentData/:data_id"
                component={StudentData}
              />
              <Route
                path="/AdminMain/ExamMarkingSystem/:exam_id/:session_id"
                component={ExamMarkingSystem}
              />
              <Route
                path="/AdminMain/ExamMarkingSystemAnnual/:report_card_id/:session_id"
                component={ExamMarkingSystemAnnual}
              />
              <Route
                path="/AdminMain/PrintableDocs/:document_type/"
                component={PrintableDocs}
              />
              <Route
                path="/AdminMain/PdAdmissionForm/:document_type/"
                component={PdAdmissionForm}
              />
              <Route
                path="/AdminMain/PrintableDocsIdCard/:document_type/"
                component={PrintableDocsIdCard}
              />
              <Route path="/AdminMain/Siblings" component={Siblings} />
              <Route
                path="/AdminMain/PrintableDocsAdmitCard/:document_type/"
                component={PrintableDocsAdmitCard}
              />
              <Route
                path="/AdminMain/PrintableDocsResult/:document_type/"
                component={PrintableDocsResult}
              />
              <Route
                path="/AdminMain/PrintableDocsBlank/:document_type/"
                component={PrintableDocsBlank}
              />

              <Route
                path="/AdminMain/TransportRoutes"
                component={TransportRoutes}
              />
              <Route
                path="/AdminMain/TransportVehicles"
                component={TransportVehicles}
              />
              <Route
                path="/AdminMain/TransportStudent"
                component={TransportStudent}
              />
              <Route
                path="/AdminMain/TransportAddNewRoute"
                component={TransportAddNewRoute}
              />
              <Route
                path="/AdminMain/ManageTransportFee"
                component={ManageTransportFee}
              />
              <Route
                path="/AdminMain/TransportAttendance"
                component={TransportAttendance}
              />
              <Route
                path="/AdminMain/TransportPermission"
                component={TransportPermission}
              />
              <Route path="/AdminMain/DriverDetails" component={DriverDetails} />
              <Route path="/AdminMain/ExamCreation" component={ExamCreation} />
              <Route path="/AdminMain/ClassChange" component={ClassChange} />
              <Route path="/AdminMain/SessionJump" component={SessionJump} />
              <Route
                path="/AdminMain/SectionShift/:class_id/:section_id/:session_id?"
                component={SectionShift}
              />
              <Route
                path="/AdminMain/TransferCertificatePreview"
                component={TransferCertificatePreview}
              />
              <Route
                path="/AdminMain/TransferCertificate"
                component={TransferCertificate}
              />
              <Route
                path="/AdminMain/TransferCertificateForm"
                component={TransferCertificateForm}
              />
              <Route path="/AdminMain/SrNumber" component={SrNumber} />
              <Route
                path="/AdminMain/EditStudentDetails/:student_id"
                component={EditStudentDetails}
              />
              <Route
                path="/AdminMain/FeeReceiptSettings"
                component={FeeReceiptSettings}
              />
              <Route
                path="/AdminMain/DepartmentSettings"
                component={DepartmentSettings}
              />
              <Route
                path="/AdminMain/RollNumberManagement"
                component={RollNumberManagement}
              />
              <Route
                path="/AdminMain/ManageAdmissionDate"
                component={ManageAdmissionDate}
              />
              <Route
                path="/AdminMain/ManageAdmissionType"
                component={ManageAdmissionType}
              />
              <Route path="/AdminMain/SubjectList" component={SubjectList} />
              <Route
                path="/AdminMain/SessionSettings"
                component={SessionSettings}
              />
              <Route
                path="/AdminMain/SignSettings"
                component={SignSettings}
              />
              <Route path="/AdminMain/FontSettings" component={FontSettings} />
              <Route
                path="/AdminMain/CertificateSettings"
                component={CertificateSettings}
              />
              <Route
                path="/AdminMain/BoardMediumSettings"
                component={BoardMediumSettings}
              />
              
              <Route path="/AdminMain/ClassSubject" component={ClassSubject} />
              <Route path="/AdminMain/QuestionBank" component={QuestionBank} />
              <Route
                path="/AdminMain/AddQuestionBank"
                exact
                component={AddQuestionBank}
              />
              <Route
                path="/AdminMain/AddQuestionBank/:id"
                component={AddQuestionBank}
              />
              <Route
                path="/AdminMain/QuestionPapers"
                component={QuestionPapers}
              />
              <Route
                path="/AdminMain/PaperBuilder"
                exact
                component={PaperBuilder}
              />
              <Route
                path="/AdminMain/PaperBuilder/:id"
                component={PaperBuilder}
              />
              <Route
                path="/AdminMain/PrintQuestionPaper/:document_type/:paper_id"
                component={PrintQuestionPaper}
              />
              <Route
                path="/AdminMain/PrintQuestionPaper/:paper_id"
                exact
                component={PrintQuestionPaper}
              />
              <Route
                path="/AdminMain/TimetableBuilder"
                exact
                component={TimetableBuilder}
              />
              <Route
                path="/AdminMain/TimetableBuilder/:id"
                component={TimetableBuilder}
              />

              <Route
                path="/AdminMain/ClassMarkStatus"
                component={ClassMarkStatus}
              />
              <Route
                path="/AdminMain/StudentMarkDetails"
                component={StudentMarkDetails}
              />
              <Route
                path="/AdminMain/ExamAddSingleStudentMark"
                component={ExamAddSingleStudentMark}
              />
              <Route
                path="/AdminMain/StaffProfile/:Staff_id"
                component={StaffProfile}
              />
              <Route
                path="/AdminMain/AddNewSibling"
                component={AddNewSibling}
              />
              <Route
                path="/AdminMain/DeleteStudent"
                component={DeleteStudent}
              />
              <Route path="/AdminMain/DeleteStaff" component={DeleteStaff} />
              <Route path="/AdminMain/DeleteExam" component={DeleteExam} />
              <Route
                path="/AdminMain/ExamAddMarkStudentWise/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamAddMarkStudentWise}
              />
              <Route
                path="/AdminMain/ExamAddMarkSubjectWise/:exam_id/:session_id/:exam_name/:exam_status"
                component={ExamAddMarkSubjectWise}
              />
              <Route
                path="/AdminMain/PrintableDocsTopper/:document_type/"
                component={PrintableDocsTopper}
              />
              <Route
                path="/AdminMain/CompetitionAward/:document_type/"
                component={CompetitionAward}
              />
              <Route
                path="/AdminMain/ExamReportCardRankList/:report_card_id/:session_id"
                component={ExamReportCardRankList}
              />
              <Route
                path="/AdminMain/ExamReportCardResultSheet/:report_card_id/:session_id"
                component={ExamReportCardResultSheet}
              />
              <Route
                path="/AdminMain/ExamReportCardAttendanceReport/:report_card_id/:session_id/:manual_attendance/"
                component={ExamReportCardAttendanceReport}
              />
              <Route
                path="/AdminMain/SchoolWorkingDays/:report_card_id/:session_id"
                component={SchoolWorkingDays}
              />
              <Route
                path="/AdminMain/SchoolWorkingDays"
                exact
                component={SchoolWorkingDays}
              />
              <Route
                path="/AdminMain/ExamReportCardCrossList/:report_card_id/:session_id"
                component={ExamReportCardCrossList}
              />
              <Route
                path="/AdminMain/ExamReportCardGauzzat/:report_card_id/:session_id"
                component={ExamReportCardGauzzat}
              />
              <Route path="/AdminMain/Aadhaar" component={Aadhaar} />
              <Route path="/AdminMain/ParentsAadhar" component={ParentsAadhar} />
              <Route
                path="/AdminMain/ManageStudentApaar"
                component={ManageStudentApaar}
              />
              <Route
                path="/AdminMain/StateSpecificId"
                component={StateSpecificId}
              />
              <Route path="/AdminMain/Dob" component={Dob} />

              <Route path="/AdminMain/BloodGroup" component={BloodGroup} />
              <Route path="/AdminMain/Gender" component={Gender} />
              <Route
                path="/AdminMain/ManageStudentImage"
                component={ManageStudentImage}
              />
              <Route path="/AdminMain/MotherTongue" component={MotherTongue} />
              <Route
                path="/AdminMain/HeightAndWeight"
                component={HeightAndWeight}
              />
              <Route
                path="/AdminMain/BplBeneficiary"
                component={BplBeneficiary}
              />
              <Route
                path="/AdminMain/PhysicalDisability"
                component={PhysicalDisability}
              />
              <Route path="/AdminMain/StudentPen" component={StudentPen} />
              <Route
                path="/AdminMain/ExamSignSheet/:document_type/"
                component={ExamSignSheet}
              />
              <Route
                path="/AdminMain/DemandSlip/:document_type/"
                component={DemandSlip}
              />

              <Route
                path="/AdminMain/UdiseForm/:document_type/"
                component={UdiseForm}
              />
              <Route
                path="/AdminMain/StudentAttendanceReport/:document_type/"
                component={StudentAttendanceReport}
              />

              <Route
                path="/AdminMain/StudentSubject"
                component={StudentSubject}
              />
              <Route
                path="/AdminMain/AlternateSubject"
                component={AlternateSubject}
              />

              <Route
                path="/AdminMain/MarkEntryForm/:document_type/"
                component={MarkEntryForm}
              />
              <Route
                path="/AdminMain/MarkEntryCheckList/:document_type/"
                component={MarkEntryCheckList}
              />
              <Route
                path="/AdminMain/ExamSchedule/:document_type/"
                component={ExamSchedule}
              />

              <Route
                path="/AdminMain/StudentDueList/:document_type/"
                component={StudentDueList}
              />
              <Route
                path="/AdminMain/PrintableDocsEvent/:document_type/"
                component={PrintableDocsEvent}
              />
              <Route
                path="/AdminMain/AppreciationCertificate/:document_type/"
                component={AppreciationCertificate}
              />
              <Route
                path="/AdminMain/StudentCertificate/:document_type"
                component={StudentCertificate}
              />
              <Route
                path="/AdminMain/StudentCertificate"
                exact
                component={StudentCertificate}
              />
              <Route
                path="/AdminMain/EventInvitation/:event_id"
                component={EventInvitation}
              />
              <Route
                path="/AdminMain/EventCertificate/:event_id"
                component={EventCertificate}
              />
              <Route
                path="/AdminMain/StaffOfferLetter/:document_type/"
                component={StaffOfferLetter}
              />
              <Route
                path="/AdminMain/LetterHead/:document_type/"
                component={LetterHead}
              />

              <Route
                path="/AdminMain/TransportRoutesDetails/:route_id"
                component={TransportRoutesDetails}
              />
              <Route
                path="/AdminMain/AccessoriesAddCategory"
                component={AccessoriesAddCategory}
              />

              <Route
                path="/AdminMain/AccessoriesCollection"
                component={AccessoriesCollection}
              />
              <Route
                path="/AdminMain/AccessoriesDetails"
                component={AccessoriesDetails}
              />
              <Route
                path="/AdminMain/IssueAccessories"
                component={IssueAccessories}
              />
              <Route
                path="/AdminMain/AccessoriesList"
                component={AccessoriesList}
              />
              <Route path="/AdminMain/AppUser/:module_id" component={AppUser} />
              <Route
                path="/AdminMain/OldDueCollection/:student_id/:session_id"
                component={OldDueCollection}
              />
              <Route path="/AdminMain/AddOldDue" component={AddOldDue} />
              <Route
                path="/AdminMain/DemandNotice/:document_type/"
                component={DemandNotice}
              />

              <Route
                path="/AdminMain/StaffLeaveDetails"
                component={StaffLeaveDetails}
              />
              <Route
                path="/AdminMain/StudentPassword"
                component={StudentPassword}
              />
              <Route path="/AdminMain/StaffLeave" component={StaffLeave} />
              <Route path="/AdminMain/StudentLeave" component={StudentLeave} />
              <Route
                path="/AdminMain/PromoteTransportStudent"
                component={PromoteTransportStudent}
              />
              <Route
                path="/AdminMain/OldDueOtherAmount"
                component={OldDueOtherAmount}
              />

              <Route
                path="/AdminMain/MonthAttendance"
                component={MonthAttendance}
              />
              <Route
                path="/AdminMain/StudentAttendance"
                component={StudentAttendanceList}
                exact
              />
              <Route
                path="/AdminMain/StudentAttendanceDetail/:class_id/:section_id/:enrollment_no/:class_name/:section_name/:stu_name"
                component={StudentAttendanceDetail}
              />
              <Route
                path="/AdminMain/TransportStudentDetails"
                component={TransportStudentDetails}
              />
              <Route
                path="/AdminMain/AddTransportStudent"
                component={AddTransportStudent}
              />
              <Route
                path="/AdminMain/AddTransportStudentMultiple"
                component={AddTransportStudentMultiple}
              />

              <Route
                path="/AdminMain/UdiseReport/:document_type/"
                component={UdiseReport}
              />
              <Route
                path="/AdminMain/ManageCategory"
                component={ManageCategory}
              />
              <Route path="/AdminMain/ManageCaste" component={ManageCaste} />
              <Route
                path="/AdminMain/ManageStudentContacts"
                component={ManageStudentContacts}
              />
              <Route
                path="/AdminMain/PrintableDocsStaffId/:document_type/"
                component={PrintableDocsStaffId}
              />
              <Route
                path="/AdminMain/TransportReport/:document_type/"
                component={TransportReport}
              />
              <Route
        path="/AdminMain/PrintableDocsDeskSlip/:document_type/"
        component={PrintableDocsDeskSlip}
      />
              <Route path="/AdminMain/WhatsAccountSettings" component={WhatsAccountSettings} />
              <Route path="/AdminMain/WhatsAppQueue" component={CommWhatsAppQueue} />
              <Route path="/AdminMain/WhatsAppInbox" component={CommWhatsAppInbox} />
              <Route
                path="/AdminMain/CommunicationPanel/:module_id"
                component={CommunicationPanel}
              />
              <Route path="/AdminMain/CommunicationPanel" component={CommunicationPanel} />
              <Route path="/AdminMain/FineRule" component={FineRuleSettings} />
              <Route
          path="/AdminMain/ManageSocialValueField/:exam_id/:session_id/:exam_name/:exam_status"
          component={ManageSocialValueField}
        />
        <Route
          path="/AdminMain/ManageCoEducationField/:exam_id/:session_id/:exam_name/:exam_status"
          component={ManageCoEducationField}
        />
        <Route
          path="/AdminMain/AddMarkCoEducationField/:exam_id/:session_id/:exam_name"
          component={AddMarkCoEducationField}
        />
        <Route
          path="/AdminMain/AddExamSocialValueField/:exam_id/:session_id/:exam_name"
          component={AddExamSocialValueField}
        />
         <Route
        path="/AdminMain/CollectionReport/:document_type/"
        component={CollectionReport}
      />
       <Route
          path="/AdminMain/ExamDateSheet/:exam_id/:session_id/:exam_name/:exam_status"
          component={ExamDateSheet}
        />

              <Route path="/AdminMain/EventList" component={EventList} />
              <Route
                path="/AdminMain/ManageEventParticipant/:event_id/:session_id"
                component={ManageEventParticipant}
              />
          </Switch>
        </div>
      );
}

export default AdminMain;
